import { App } from 'antd'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import companyGroupQueryKeys from './companyGroupQueryKeys'
import { deleteSubsidiary } from '../service/subsidiaryService'
import { Company } from '../../../types/company/Company'
import { CompanyGroup } from './getCompanyGroupOptions'

export const useDeleteSubsidiary = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()
  const { message } = App.useApp()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: (subsidiaryId: Company['id']) => {
      if (!companyId) throw new Error('Company ID is required')
      return deleteSubsidiary(companyId, subsidiaryId)
    },
    onSuccess: updatedList => {
      queryClient.setQueryData<CompanyGroup>(companyGroupQueryKeys.group({ companyId }), old =>
        old ? { ...old, subsidiaries: updatedList } : old
      )
      queryClient.invalidateQueries({ queryKey: companyGroupQueryKeys.group({ companyId }) })
      message.success(t('messages:deleteSuccess'))
    },
    onError: () => {
      message.error(t('messages:deleteError'))
    }
  })
}
